import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import search from "../../assets/images/devlisting/search.svg";

const SearchListing = () => {
  const [active, setActive] = useState(false);
  const handleSearch = () => {
    setActive(!active);
  };

  return (
    <div className='search-content'>
      <Form>
        <Form.Group className='search-box' onClick={handleSearch}>
          <img src={search} alt='search' />
          <Form.Control type='search' placeholder='Search' />
          {active && (
            <div className='search-btn'>
              <Button>
                {/* <img src={search} alt='search' /> */}
                Search
              </Button>
            </div>
          )}
          {active && (
            <div className='search-content-items'>
              <div className='search-content-dropdown'>
                <div className='search-content-detail'>
                  <p>Categories</p>
                  <div className='search-item'>
                    <div className='search-item-box'>
                      <span>Backend</span>
                    </div>
                    <div className='search-item-box'>
                      <span>Frontend</span>
                    </div>
                    <div className='search-item-box'>
                      <span>Fullstack</span>
                    </div>
                    <div className='search-item-box'>
                      <span>Mobile</span>
                    </div>
                  </div>
                </div>
                <div className='search-content-detail'>
                  <p>Technologies</p>
                  <div className='search-item'>
                    <div className='search-item-box'>
                      <span>Git</span>
                    </div>
                    <div className='search-item-box'>
                      <span>JavaScript</span>
                    </div>
                    <div className='search-item-box'>
                      <span>.NET</span>
                    </div>
                    <div className='search-item-box'>
                      <span>SQL</span>
                    </div>
                  </div>
                </div>
                <div className='search-content-detail'>
                  <p>Locations</p>
                  <div className='search-item'>
                    <div className='search-item-box'>
                      <span>Backend</span>
                    </div>
                    <div className='search-item-box'>
                      <span>Frontend</span>
                    </div>
                    <div className='search-item-box'>
                      <span>Fullstack</span>
                    </div>
                    <div className='search-item-box'>
                      <span>Mobile</span>
                    </div>
                  </div>
                </div>
                <div className='search-content-detail'>
                  <p> Salaries</p>
                  <div className='search-item'>
                    <div className='search-item-box'>
                      <span> 10k PLN</span>
                    </div>
                    <div className='search-item-box'>
                      <span>15k PLN</span>
                    </div>
                    <div className='search-item-box'>
                      <span>20k PLN</span>
                    </div>
                    <div className='search-item-box'>
                      <span>25k PLN</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Form.Group>
      </Form>
    </div>
  );
};

export default SearchListing;
